import { DialogueUIOptionConfig } from "../../components/ui/YouRespondUI";
import { NurseStationComputerUIConfig } from "../../components/ui/NurseStationComputerUI";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { Segments } from "../../cvp-webgames-core/Scenario/Segments";
import { constants } from "../../misc/constants";
import { CalmBaseScenario } from "../CalmBaseScenario";
import Scenario4 from "./Scenario4";

export default class Scenario4Part6 extends BaseScenarioPart<CalmBaseScenario> {
	// <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< THIS sCENARIO PART IS BEING SKIPPED SINCE THERE ARE NO INTERACTIONS, JUST VIDEOS>>>>>>>>>>>
	// <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< THE SCENARIO4.TS IS SET TO GO FROM PART 5 TO PART 7, SO ANY CHANGES HERE WILL NOT BE REFLECTED
	private partIndx = 0;

	chapterIds = {
		scenario4_1b_s11: 'CALM - Scenario 4 - 1B - Segment 11',
		scenario4_4A_s12: 'CALM - Scenario 4 - 4A - Segment 12',
		
	}

	constructor(scenario: Scenario4, private onDone: () => void) {
		super(scenario);
		CalmBaseScenario.partIndx = this.partIndx;
	}

	public get videoUrl(): string[] {
		return ['./assets/videos/scenario4/calm-scenario4-avatar' + this.scenario.avatarIndx + '.mp4'];
	}

	public get partId(): string {
		return constants.scenarios.scenario4.parts.level4Part6.id;
	}

	public start() {
		const context = this;
		context.segment1Step1BenApproaches();

	}

	private segment1Step1BenApproaches() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('Receive update from Ben');
		context.playVideoChapter(this.chapterIds.scenario4_1b_s11, () =>
			context.segment1Step2TristaCalls())
			context.scenario.updateObjective('');
	}

	private segment1Step2TristaCalls() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('');
		context.playVideoChapter(this.chapterIds.scenario4_4A_s12, () =>
			context.onDone())
	}
	
}